export default "__VITE_ASSET__C52U8SUH__"